// extracted by mini-css-extract-plugin
module.exports = {"embla__button":"EmblaCarouselArrowButtons_embla__button__BoHpg","embla__button__svg":"EmblaCarouselArrowButtons_embla__button__svg__nTA1M"};